import { Button, Form, Modal } from "react-bootstrap";

import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { LLMVisitFeedback } from "../../../../amplify/api-gateway/query";
import { PatientVisit } from "../../../../amplify/api-gateway/search-patients";
import { callWrite, UPDATE_LLM_VISIT_FEEDBACK } from "../../../../amplify/api-gateway/write";

/**
 * Modal allow users to provide more detailed feedback
 */
export const LLMDashboardFeedbackModal = (props: {
    showModal: boolean,
    setShowModal: any,
    patientVisit: PatientVisit,
    feedbackTarget: string,
    feedbackType: string,
    existingReview?: LLMVisitFeedback,
    feedbacks: LLMVisitFeedback[] | undefined,
    setFeedbacks: any,
}) => {

    const [submitting, setSubmitting] = useState(false);
    const [feedback, setFeedback] = useState(props.existingReview ? props.existingReview.note : "");

    const sendFeedback = async () => {
        if (props.patientVisit) {
            setSubmitting(true);
            callWrite({
                operation: UPDATE_LLM_VISIT_FEEDBACK,
                creation_time: new Date().getTime(),
                csn: props.patientVisit.csn,
                mrn: props.patientVisit.mrn,
                feedback_target: props.feedbackTarget,
                feedback_type: props.feedbackType,
                note: feedback ?? (props.existingReview ? props.existingReview.note : ""),
            }).then((response) => {
                setSubmitting(false);
                // Check if response is empty or has an error
                if (!response || Object.keys(response).length === 0) {
                    window.alert("Failed to submit feedback. Server returned an empty response.");
                    return false;
                }
                const feedbackList = props.feedbacks ?? [];
                props.setFeedbacks([
                    ...feedbackList,
                    response,
                ]);
            });
        }
        props.setShowModal(false);
    };

    const handleClose = () => {
        props.setShowModal(false);
    };

    return (
        <Modal show={props.showModal} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Feedback Details (Optional)</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Provide any additional feedback</Form.Label>
                        <Form.Control as="textarea" rows={3} value={feedback} onChange={(event) => {setFeedback(event.target.value)}} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="secondary" onClick={() => sendFeedback()} disabled={submitting}>
                    {
                        submitting ? (
                            <FontAwesomeIcon icon={faSpinner} spin />
                        ) : (
                            <>Submit Feedback</>
                        )
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
